import instance from './instance';

export const fetchReviewForm = (slug: string) => instance.get(`/review_forms/${slug}`);

export const submitReviewForm = (slug: string, data) => instance.put(`/review_forms/${slug}`, data);

export const reopenReviewForm = (slug: string) => instance.put(`/review_forms/${slug}/reopen`, {});

export const unsubmitReviewForm = (slug: string, data) => instance.put(`/review_forms/${slug}`, data);

export const createReviewForm = data => instance.post(`/review_forms`, data);

export const createReviewFormEditingSession = (slug: string) => instance.post(`/review_forms/${slug}/editing_session`);

export const deleteReviewForm = (slug: string) => instance.delete(`/review_forms/${slug}`);

export const updateReviewFormCompiler = (slug: string, data) =>
  instance.put(`/review_forms/${slug}/update_compiler`, data);
